var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "price_svg__svg_price",
  width: 33.251,
  height: 33.855
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "price_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_156",
  fill: "none",
  d: "M0-1559.059h33.251v33.855H0z",
  transform: "translate(0 1559.059)"
})), /*#__PURE__*/React.createElement("style", null, ".price_svg__cls-4{fill:#f4be1a}.price_svg__cls-5{fill:#dca814}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "price_svg__svg_price-2",
  clipPath: "url(#price_svg__clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_485",
  transform: "translate(3.627)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_143",
  fill: "#ffd948",
  d: "M-667.276-1525.2c-8.18 0-14.812-7.579-14.812-16.927s6.631-16.928 14.812-16.928 14.812 7.579 14.812 16.928-6.632 16.927-14.812 16.927",
  transform: "translate(682.088 1559.059)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_486"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_144",
  d: "M-163.416-762.6c0-8.646 5.674-15.774 13-16.8a13 13 0 0 0-1.814-.13c-8.18 0-14.812 7.579-14.812 16.928s6.632 16.928 14.812 16.928a13 13 0 0 0 1.814-.131c-7.324-1.023-13-8.151-13-16.8",
  className: "price_svg__cls-4",
  transform: "translate(167.043 779.53)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_487",
  transform: "translate(6.448 3.311)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_145",
  d: "M-592.9-57.522a1 1 0 0 1-.071 0 10 10 0 0 0-1.1-.063.616.616 0 0 1-.617-.6.594.594 0 0 1 .592-.6h.025a11 11 0 0 1 1.239.072.6.6 0 0 1 .531.67.6.6 0 0 1-.6.535m-5.807 1.057a.6.6 0 0 1-.539-.33.6.6 0 0 1 .264-.813 11 11 0 0 1 1.159-.51.6.6 0 0 1 .778.354.605.605 0 0 1-.355.778 10 10 0 0 0-1.033.455.6.6 0 0 1-.273.066m10.266.574a.6.6 0 0 1-.329-.1 10 10 0 0 0-.981-.565.6.6 0 0 1-.267-.812.6.6 0 0 1 .812-.267 11 11 0 0 1 1.095.631.6.6 0 0 1 .177.837.6.6 0 0 1-.507.274m-13.955 2.436a.6.6 0 0 1-.382-.137.6.6 0 0 1-.085-.851c.267-.326.55-.641.841-.934a.606.606 0 0 1 .855 0 .6.6 0 0 1 0 .855q-.398.4-.763.847a.6.6 0 0 1-.468.222m17.335.92a.6.6 0 0 1-.5-.266 12 12 0 0 0-.683-.914.6.6 0 0 1 .082-.851.605.605 0 0 1 .851.082c.263.32.516.658.751 1.005a.6.6 0 0 1-.161.84.6.6 0 0 1-.339.1m-19.63 3.26a.6.6 0 0 1-.195-.033.6.6 0 0 1-.378-.767c.134-.393.285-.785.452-1.166a.605.605 0 0 1 .8-.312.6.6 0 0 1 .312.8c-.153.349-.292.709-.414 1.069a.61.61 0 0 1-.573.411m21.565 1.1a.6.6 0 0 1-.585-.456c-.094-.372-.2-.742-.326-1.1a.6.6 0 0 1 .376-.768.6.6 0 0 1 .768.376q.202.588.355 1.2a.6.6 0 0 1-.438.734.6.6 0 0 1-.149.019m-22.33 3.6a.6.6 0 0 1-.6-.6v-.013c0-.412.016-.827.048-1.232a.606.606 0 0 1 .651-.555.6.6 0 0 1 .555.651c-.03.374-.045.756-.045 1.136a.61.61 0 0 1-.6.611m22.728 1.152h-.047a.605.605 0 0 1-.556-.65c.028-.366.043-.741.043-1.111a.62.62 0 0 1 .6-.624.59.59 0 0 1 .6.585v.039c0 .4-.016.807-.047 1.2a.6.6 0 0 1-.6.558m-21.955 3.565a.61.61 0 0 1-.573-.41c-.134-.392-.252-.8-.352-1.2a.6.6 0 0 1 .44-.732.6.6 0 0 1 .733.44c.092.371.2.741.324 1.1a.6.6 0 0 1-.376.767.6.6 0 0 1-.2.033m20.813 1.068a.6.6 0 0 1-.241-.05.605.605 0 0 1-.313-.8c.152-.347.29-.707.412-1.069a.605.605 0 0 1 .766-.38.605.605 0 0 1 .38.766c-.133.395-.284.788-.449 1.167a.61.61 0 0 1-.555.363m-18.508 3.106a.6.6 0 0 1-.468-.221c-.262-.32-.514-.659-.748-1.007a.6.6 0 0 1 .163-.84.6.6 0 0 1 .839.163q.321.477.681.916a.605.605 0 0 1-.084.851.6.6 0 0 1-.383.137m15.85.851a.6.6 0 0 1-.424-.173.6.6 0 0 1 0-.855 11 11 0 0 0 .76-.848.605.605 0 0 1 .851-.088.6.6 0 0 1 .088.851c-.267.328-.549.643-.84.936a.6.6 0 0 1-.429.179m-12.158 2.151a.6.6 0 0 1-.273-.066 12 12 0 0 1-1.094-.634.6.6 0 0 1-.175-.837.606.606 0 0 1 .837-.175 10 10 0 0 0 .978.567.6.6 0 0 1 .265.813.6.6 0 0 1-.539.331m8.183.462a.6.6 0 0 1-.566-.392.6.6 0 0 1 .352-.779 10 10 0 0 0 1.031-.458.6.6 0 0 1 .814.262.6.6 0 0 1-.262.814 11 11 0 0 1-1.157.513.6.6 0 0 1-.213.039m-3.516.651h-.052a11 11 0 0 1-1.267-.075.6.6 0 0 1-.529-.672.61.61 0 0 1 .672-.528 10 10 0 0 0 1.123.067.627.627 0 0 1 .631.6.58.58 0 0 1-.579.6",
  className: "price_svg__cls-4",
  transform: "translate(606.057 58.799)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_488",
  transform: "translate(0 17.532)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_146",
  d: "M-163.36 0h-3.626q.017.61.072 1.209h3.629q-.056-.6-.075-1.209",
  className: "price_svg__cls-5",
  transform: "translate(166.986)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_489",
  transform: "translate(.028 14.51)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_147",
  d: "M-168.318 0h-3.625c-.05.4-.086.8-.111 1.209h3.627c.027-.409.059-.809.109-1.209",
  className: "price_svg__cls-5",
  transform: "translate(172.054)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_490",
  transform: "translate(.331 20.555)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_148",
  d: "M-163.442 0h-3.628q.118.613.273 1.209h3.627q-.154-.6-.271-1.209",
  className: "price_svg__cls-5",
  transform: "translate(167.07)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_491",
  transform: "translate(1.175 23.578)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_149",
  d: "M-163.524 0h-3.63q.233.617.506 1.209h3.628q-.272-.591-.5-1.209",
  className: "price_svg__cls-5",
  transform: "translate(167.154)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_492",
  transform: "translate(.453 11.487)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_150",
  d: "M-177.631 0h-3.623c-.118.4-.228.8-.32 1.209h3.632q.137-.614.311-1.209",
  className: "price_svg__cls-5",
  transform: "translate(181.574)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_493",
  transform: "translate(1.414 8.464)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_151",
  d: "M-188.607 0h-3.627c-.2.394-.388.8-.559 1.209h3.63q.258-.618.557-1.209",
  className: "price_svg__cls-5",
  transform: "translate(192.794)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_494",
  transform: "translate(3.456 4.837)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_152",
  d: "M-207.783 0h-3.632q-.516.577-.981 1.209h3.63q.465-.632.982-1.209",
  className: "price_svg__cls-5",
  transform: "translate(212.395)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_495",
  transform: "translate(6.355 1.814)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_153",
  d: "M-243.733 0h-3.635a14.5 14.5 0 0 0-1.775 1.209h3.633A14.6 14.6 0 0 1-243.733 0",
  className: "price_svg__cls-5",
  transform: "translate(249.143)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_496",
  transform: "translate(3.032 27.205)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_154",
  d: "M-163.5 0h-3.629q.421.628.89 1.209h3.632q-.47-.58-.892-1.209",
  className: "price_svg__cls-5",
  transform: "translate(167.126)"
})), /*#__PURE__*/React.createElement("g", {
  id: "price_svg__\\uADF8\\uB8F9_497",
  transform: "translate(5.642 30.228)"
}, /*#__PURE__*/React.createElement("path", {
  id: "price_svg__\\uD328\\uC2A4_155",
  d: "M0 0a15 15 0 0 0 1.526 1.209h3.636A15 15 0 0 1 3.626 0z",
  className: "price_svg__cls-5"
})))));
export { SvgPrice as ReactComponent };
export default __webpack_public_path__ + "static/media/price.7f84e5f7.svg";